export default "/images/vendor/flag-icon-css/flags/4x3/tt.svg?33069ab84c09c8db0b08fc24b358ca63";